import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { DateService } from '../../shared/core/date.service';
import { ServerEntity } from '../../shared/shared/interfaces/server-entity';
import { FormConfigService } from '../core/form-config.service';
import { FormsService } from '../core/forms.service';
import { FormConfig, FormField } from '../shared/form-config-abstract';
import { FormType } from '../shared/form-type.enum';

@Component({
  selector: 'rl-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss', './form.component-rtl.css']
})
export class FormComponent implements OnInit {

  @Input() type : FormType;
  @Input() fromFile? : boolean = false;
  @Input() config? : FormConfig<ServerEntity>;
  
  form : UntypedFormGroup;
  fileUploaded : boolean = false;
  dateConfig : any = {}; // should be token
  showErrors : boolean;

  constructor(private formsService : FormsService, private formConfigService : FormConfigService, private dateService : DateService) { }

  ngOnInit(): void {
    this.config = this.config || this.formConfigService.getConfig(this.type);

    if(this.config.init) this.config.init();
    this.form =  this.formsService.toFormGroup(this.config);
 }

  setFields(item : any) : void{
    for (let i = 0; i< this.config.fields.length; i++) {
      let f = this.config.fields[i];
      if(f instanceof Array){
        for (let j = 0; j < f.length; j++) {
          this.setDefaultValue(f[j], item)
        }
      }else{
        this.setDefaultValue(f, item)
      }
    };
  }

  setDefaultValue(f : FormField<any>, item : any){
    let value;
    if(f.name instanceof Array){
      value = [];
      f.name.forEach(f => value.push(item[f]));
    }else{
      value = item[f.name];
    }

    if(f.type == 'date' && value){
      value = new Date(value);
    }else if(f.type == 'dateRange' && (item.start || item.end)){
      let start = item.start ? new Date(item.start) : '';
      let end = item.end ? new Date(item.end) : '';
      value = [start, end];
    }
    let controlName = f.controlName || f.name instanceof Array ?  f.controlName : f.name;
    this.form.controls[controlName].setValue(value || '');
  }
  
  reset = () => {
	this.form.reset();
  	this.setFields({});
  }

  save(item : any = {}) : Observable<ServerEntity> {
    this.showErrors = false;
    Object.assign(item, this.formsService.toEntity(this.form.value, this.config));
    return item.id ? this.config.apiService().save(item) : this.config.apiService().create(item);
  }

  validate(){
    this.showErrors = true;
    return this.form.valid;
  }

  isControlValid = (ctrlName : string) => this.form.controls[ctrlName]?.valid;
}